import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import "../Css/Detail.scss";
import axios from "axios";
import { FcOnlineSupport, FcPhone, FcViewDetails } from "react-icons/fc";
import no_img_creative from "../../images/no_img_creative.png";
import { Link } from "react-router-dom";
import { apiUrl } from "../../config/index.js";
export default function CreativePage(props) {
  const { co_researcher_id } = props;
  const [creative, setcreative] = useState([]);
  const [countall, setcountall] = useState("");
  const [creativeproject, setcreativeproject] = useState([]);
  const [creative_district, setcreative_district] = useState([]);
  const [creative_community, setcreative_community] = useState([]);
  const [creative_phi, setcreative_phi] = useState([]);
  let id = atob(co_researcher_id);

  useEffect(() => {
    axios
      .get(
        `${apiUrl}/api/get/co-researcher/innovation/images/type?co_id=${id}&pi_type_id=3`
      )
      .then((result) => {
        setcountall(result.data.count_all);
        if (result.data.creativesproject) {
          setcreativeproject(result.data.creativesproject);
        }
        if (result.data.creatives) {
          setcreative(result.data.creatives);
        }
        if (result.data.details) {
          result.data.details.forEach((el) => {
            if (el.co_group_name === "ตำบล") {
              if (el.creatives.length) {
                setcreative_district(el);
              }
            } else if (el.co_group_name === "ชุมชน") {
              if (el.creatives.length) {
                setcreative_community(el);
              }
            } else if (el.co_group_name === "ปราชญ์") {
              if (el.creatives.length) {
                setcreative_phi(el);
              }
            }
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const DetailPage = (obj) => {
    let { innovations } = obj;
    return (
      <>
        {innovations.map(function (listValue, i) {
          var url_image = "";
          if (listValue.co_researcher_pi_image) {
            url_image = `https://researcher.kims-rmuti.com/file-upload/co_innovationproduct_upload/${listValue.co_researcher_pi_image}`;
          } else if (listValue.images.length > 0) {
            if (listValue.images[0].co_innovation_image) {
              url_image = `https://researcher.kims-rmuti.com/file-upload/${
                listValue.innovation_id
                  ? "us_innovation-upload"
                  : "co_innovationproduct_upload"
              }/${listValue.images[0].co_innovation_image}`;
            }
          } else {
            url_image = no_img_creative;
          }
          const url = `/InnovationDetail?type=innovation&innovationid=${
            listValue.co_researcher_pi_id
              ? listValue.co_researcher_pi_id
              : listValue.innovation_id
          }&typetable=${listValue.innovation_id ? "ustable" : "cotable"}`;

          return (
            <Col xs={12} sm={6} md={6} lg={4} style={{ padding: "1rem 1rem" }}>
              <div
                className="card card-bg-innovation card-innovation"
                style={{
                  boxShadow: "14px 13px 0px -5px rgb(159 159 159 / 37%)",
                  padding: "0.5rem",
                  backgroundColor: "#fff",
                }}
              >
                <div className="card__image-holder">
                  <img
                    className="card__image img-innovation"
                    src={url_image}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = no_img_creative;
                    }}
                    alt="co_researcher_pi_image"
                  />
                </div>
                <div
                  className="card-innovation-title"
                  style={{ backgroundColor: "#fff" }}
                >
                  <h2
                    className="innovation-title"
                    style={{ paddingTop: "0.5rem" }}
                  >
                    {listValue.co_researcher_pi_name
                      ? listValue.co_researcher_pi_name
                      : listValue.innovation_name
                      ? listValue.innovation_name
                      : "-"}
                  </h2>
                  <small className="innovation">
                    ราคา:{" "}
                    {listValue.co_researcher_pi_price
                      ? listValue.co_researcher_pi_price
                      : listValue.innovation_price
                      ? listValue.innovation_price
                      : "-"}{" "}
                    บาท
                  </small>
                </div>
                <div
                  className="descriptions"
                  style={{ backgroundColor: "#fff" }}
                >
                  <h5 className="title-hover">
                    {" "}
                    {listValue.co_researcher_pi_name
                      ? listValue.co_researcher_pi_name
                      : listValue.innovation_name
                      ? listValue.innovation_name
                      : "-"}
                  </h5>
                  <p>
                    <FcViewDetails size={15} /> :{" "}
                    {listValue.co_researcher_pi_details
                      ? listValue.co_researcher_pi_details.replace(
                          /<[^>]+>|&nbsp;|&quot;/g,
                          ""
                        )
                      : "-"}{" "}
                  </p>
                  <p>
                    จำนวนการผลิต :{" "}
                    {listValue.co_researcher_pi_amount
                      ? listValue.co_researcher_pi_amount
                      : listValue.innovation_amount
                      ? listValue.innovation_amount
                      : "-"}{" "}
                    ชิ้น
                  </p>
                  <p>
                    <FcOnlineSupport size={15} /> :{" "}
                    {listValue.co_researcher_pi_coordinator
                      ? listValue.co_researcher_pi_coordinator
                      : "-"}
                  </p>
                  <p>
                    <FcPhone size={15} /> :{" "}
                    {listValue.co_researcher_pi_phone
                      ? listValue.co_researcher_pi_phone
                      : "-"}
                  </p>
                  <Link to={url} className="btn-innovation">
                    ดูเพิ่มเติม
                  </Link>
                </div>
              </div>
            </Col>
          );
        })}
      </>
    );
  };
  return (
    <div>
      <Row className="div-detail">
        <h5 style={{ paddingTop: "1rem", textAlign: "left" }}>
          งานสร้างสรรค์ทั้งหมด' {countall} รายการ
        </h5>
        <div className="line-bottom" style={{ margin: "1rem 0rem" }} />
        <DetailPage innovations={creative} />

        <h5 style={{ paddingTop: "1rem", textAlign: "left" }}>
          งานสร้างสรรค์ของโครงการ
        </h5>
        <div className="line-bottom" style={{ margin: "1rem 0rem" }} />
        <DetailPage innovations={creativeproject} />

        {Object.keys(creative_district).length ? (
          <div>
            <h5 style={{ paddingTop: "1rem", textAlign: "left" }}>
              {creative_district.co_group_name}
            </h5>
            <div className="line-bottom" style={{ margin: "1rem 1rem" }} />
            {creative_district.creatives?.map((ex, i) => (
              <div key={i}>
                <p style={{ textAlign: "left" }}>{ex.co_researcher_name_th}</p>
                <Row style={{ paddingRight: "2rem" }}>
                  <DetailPage innovations={ex.innovations} />
                </Row>
              </div>
            ))}
          </div>
        ) : null}

        {Object.keys(creative_community).length ? (
          <div>
            <h5 style={{ paddingTop: "1rem", textAlign: "left" }}>
              {creative_community.co_group_name}
            </h5>
            <div className="line-bottom" style={{ margin: "1rem 1rem" }} />
            {creative_community.creatives?.map((ex, i) => (
              <div key={i}>
                <p style={{ textAlign: "left" }}>{ex.co_researcher_name_th}</p>
                <Row style={{ paddingRight: "2rem" }}>
                  <DetailPage innovations={ex.innovations} />
                </Row>
              </div>
            ))}
          </div>
        ) : null}

        {Object.keys(creative_phi).length ? (
          <div>
            <h5 style={{ paddingTop: "1rem", textAlign: "left" }}>
              {creative_phi.co_group_name}
            </h5>
            <div className="line-bottom" style={{ margin: "1rem 1rem" }} />
            {creative_phi.creatives?.map((ex, i) => (
              <div key={i}>
                <p style={{ textAlign: "left" }}>{ex.co_researcher_name_th}</p>
                <Row style={{ paddingRight: "2rem" }}>
                  <DetailPage innovations={ex.innovations} />
                </Row>
              </div>
            ))}
          </div>
        ) : null}
        {/* {creative.length ? (
          <>
            <h5 style={{ paddingTop: "1rem", textAlign: "left" }}>
              งานสร้างสรรค์ทั้งหมด {creative.length} รายการ
            </h5>
            {creativediv}
            
          </>
        ) : (
          <h6 style={{ textAlign: "center" }}>ไม่พบข้อมูล</h6>
        )} */}
      </Row>
    </div>
  );
}




